import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCube = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M2.484,5.807l0,10.504l9.558,5.797l9.474,-5.797l0,-10.504l-9.474,-3.915l-9.558,3.915Z",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.29px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.516,5.807l-9.472,5.104l0,11.057",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.29px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.484,5.807l9.558,5.104",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.29px"
				}
			})
		]
	})
});
export default SvgCube;
